import React, {forwardRef, useEffect, useRef, useState} from 'react';
import BaseMachineAssignmentManageModal, {
  getEmptyData as getEmptyMachineAssignmentData,
} from './BaseMachineAssignmentManageModal';
import useMachineAssignment from '../hooks/useMachineAssignment';
import enumList from '../../../utils/enumList';
import {useDispatch} from 'react-redux';
import {showMessage} from '../../../utils/modalHelper';
const {messageModalMode} = enumList;

const MachineAssignmentCreateModal = (props, ref) => {
  const {
    customerData,
    getAssignments,
    listModalRef,
    modalRef: currentModalRef,
  } = props;
  const dispatch = useDispatch();
  const [machines, setMachines] = useState([]);
  const [displayMachines, setDisplayMachines] = useState([]);
  const [isValid, setIsValid] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [machineAssignment, setMachineAssignment] = useState(
    getEmptyMachineAssignmentData(),
  );
  const {fetchMachines, assign} = useMachineAssignment({
    customerCode: customerData.customerCode,
    dispatch,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsValid(true);
    let response = {};
    try {
      const {machines, deliveryDate, flgIsResold, flgOnSiteCheck} =
        machineAssignment;

      const machineIDs = machines.map(({id}) => id);
      if (
        !ref.current.getElementsByTagName('form')[0].checkValidity() ||
        !machineIDs.length
      ) {
        setIsValid(false);
        return;
      }

      response = await assign({
        machineIDs,
        deliveryDate,
        flgIsResold,
        flgOnSiteCheck,
      });
      showMessage(messageModalMode.info, '建立成功');
      setMachineAssignment(getEmptyMachineAssignmentData());
      setMachines([]);
    } catch (error) {
      console.error(error);
      showMessage(messageModalMode.error, 'error', response?.payload?.message);
    } finally {
      if (ref.current instanceof HTMLDivElement) {
        currentModalRef.current.hide();
        getAssignments();
      }
    }
  };

  const updateMachineList = async ({
    limit,
    page,
    machineSerialNumber,
    isModifyState = true,
  } = {}) => {
    setIsLoading(true);
    const {data: machines} = await fetchMachines({
      limit,
      page,
      machineSerialNumber,
    });
    const filteredMachines = machines
      .filter(
        ({customerCode, flgStatus}) =>
          customerCode === undefined &&
          flgStatus !== enumList.flgStatus.inactive,
      )
      .map(({machineId, machineSerialNumber}) => ({
        id: machineId,
        label: machineSerialNumber,
      }));

    setIsLoading(false);
    if (isModifyState) {
      setMachines((prev) => [...prev, ...filteredMachines]);
    }
    return filteredMachines;
  };

  useEffect(() => {
    if (!(ref.current instanceof HTMLDivElement)) {
      return;
    }
    const initialize = async () => {
      const {customerCode, customerName} = customerData;
      if (!customerCode) {
        console.warn(new Error('no customer code found'));
        if (ref.current instanceof HTMLDivElement) {
          currentModalRef.current.hide();
        }
        return;
      }
      setMachineAssignment({...machineAssignment, customerCode, customerName});
      const machines = await updateMachineList();
      setDisplayMachines(machines);
    };
    ref.current.addEventListener('shown.bs.modal', initialize);
    return () => {
      if (!(ref.current instanceof HTMLDivElement)) {
        return;
      }
      ref.current.removeEventListener('shown.bs.modal', initialize);
    };
  }, [customerData]);

  return (
    <BaseMachineAssignmentManageModal
      type="create"
      ref={ref}
      {...{
        ...props,
        title: {
          content: '建立機器綁定',
        },
        isLoading,
        setIsLoading,
        isValid,
        machines,
        handleSubmit,
        data: machineAssignment,
        setData: setMachineAssignment,
        currentModalRef,
        listModalRef,
        updateMachineList,
        displayMachines,
        setDisplayMachines,
      }}
    />
  );
};

export default forwardRef(MachineAssignmentCreateModal);
